import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button, Radio, Checkbox } from "cxa-components";
import messages from "../messagesDescription";

const CharityContent = ({
  onSubmit,
  onOptInSelected,
  onNotOptInSelected,
  onTaxDeductionChange,
  ...rest
}) => {
  return (
    <Fragment>
      <div className="charity-container">
        <div className="grid__wrapper">
          <div className="grid__item grid__item--seven statement-container">
            <div className="title"> {messages.charity.title}</div>
            <div className="mobile-line">
              {messages.charity.statementMobile1}
              <br />
              {messages.charity.statementMobile2}
            </div>
            <div className="line line1">{messages.charity.statement1}</div>
            <div className="line">{messages.charity.statement2}</div>
            <div className="line">{messages.charity.statement3}</div>
            <div className="line">{messages.charity.statement4}</div>
            <div className="line">{messages.charity.statement5}</div>
          </div>
          <div className="grid__item grid__item--five image-container">
            <img src="/assets/images/charity.png" alt="Charity" />
          </div>
        </div>
        <div className="grid__item grid__item--full question-container">
          <div className="desktop">{messages.charity.question1}</div>
          <div className="mobile">{messages.charity.question1Mobile}</div>
          <Radio name="optIn" onChange={onOptInSelected} {...(rest.optIn ? { checked: true } : {})}>
            {messages.charity.option1}
          </Radio>
          <Radio name="optIn" onChange={onNotOptInSelected}>
            {messages.charity.option2}
          </Radio>
          <Checkbox
            onClick={onTaxDeductionChange}
            {...(!rest.optIn ? { disabled: true, checked: false } : {})}
          >
            <span>{messages.charity.question2}</span>
          </Checkbox>
        </div>
        <div className="grid__item grid__item--full terms-container">
          <div className="title">{messages.charity.termsTitle}</div>
          <div className="terms">
            <div className="term1">{messages.charity.terms1}</div>
            <br />
            <div className="term2">{messages.charity.terms2}</div>
            <br />
            <div className="term3">{messages.charity.terms3}</div>
            <br />
            <div className="term4">{messages.charity.terms4}</div>
            <div className="term5">{messages.charity.terms5}</div>
            <div className="term6">{messages.charity.terms6}</div>
          </div>
        </div>
        <div className="grid__item grid__item--full">
          <div className="button-container">
            <Button primary type="button" onClick={onSubmit} className="btn">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CharityContent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onOptInSelected: PropTypes.func.isRequired,
  onNotOptInSelected: PropTypes.func.isRequired,
  onTaxDeductionChange: PropTypes.func.isRequired,
};

export default CharityContent;



// WEBPACK FOOTER //
// ./components/dashboard/CharityContent.js